export default "__VITE_ASSET__Cj0WN4dH__"